import { useOverlayStore } from "@/hooks/use-overlay-store"
import { aptEnsureLoaded } from "../../apt-ensure-loaded"
import { unitsStore } from "./units-store"

export const unitsLoader = async ({ request, params }) => {
  await aptEnsureLoaded(params)

  const url = new URL(request.url)
  const dong = url.searchParams.get("dong")
  const ho = url.searchParams.get("ho")
  if (dong) unitsStore.getState().setDraftDong(dong)
  if (ho) unitsStore.getState().setDraftHo(ho)

  await unitsStore.getState().apiInitial()

  useOverlayStore.getState().close()
  return null
}
